<template>
    <div style="height:80%;display: flex; justify-content: center; align-items: center">
        <div style="width: 100%">
            <div ref="plateForm" class="weui-form-area">
                <div class="weui-cells weui-cells_form">
                    <plate-input @onChange="getPlateNumber"></plate-input>
                </div>

                <div class="weui-btn-area">
                    <button class="weui-btn weui-btn_warn" @click="checkParkHour">查询停车时长</button>

                </div>

            </div>

            
    
			
       
                <!-- <article class="weui-article">
				<section>
					<div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
						<div class="weui-cell__hd" style="color: #0d0d0d"><label class="weui-label">代付时长</label></div>

						<div class="weui-cell__bd" @click="chooseRationType">
							{{ checkedCoupon }}
						</div>
					</div>
				</section>
			</article> -->
               
           




            <!-- <button class="weui-btn weui-btn_default" @click="toPay">支付</button> -->
        </div>

    </div>
</template>

<script>
import { pay } from "../../api/coupon/pay";
// import { getRecordByPlateNo } from '../../../api/coupon/platePay'
import { getRecordByPlateNo,getPrecomputation } from '../../api/coupon/platePay'
// import plateInput from '../components/plateInput'
import plateInput from './components/plateInput'
import { mapGetters } from 'vuex'

export default {
    name: "Payment",
    data() {
        return {
           
            parkinglotId: undefined,
            couponTaskId: undefined,
            plateForm: {
				bindMethod: 2,
			},
            recId:"",
            
         
            checkedCouponId: undefined,
            checkedCoupon: undefined,
            checkedCouponOptions: [

                {
                    value: '0',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '一小时'
                },
                {
                    value: '3',
                    label: '二小时'
                },
                {
                    value: '3',
                    label: '三小时'
                },
                {
                    value: '4',
                    label: '四小时'
                },
                {
                    value: '5',
                    label: '五小时'
                },
                {
                    value: '6',
                    label: '六小时'
                },
                {
                    value: '7',
                    label: '七小时'
                },
                {
                    value: '8',
                    label: '八小时'
                },
                {
                    value: '9',
                    label: '九小时'
                },
                {
                    value: '10',
                    label: '十小时'
                },
                {
                    value: '11',
                    label: '十一小时'
                },
                {
                    value: '12',
                    label: '十二小时'
                },
                {
                    value: '13',
                    label: '十三小时'
                },
                {
                    value: '14',
                    label: '十四小时'
                },
                {
                    value: '15',
                    label: '十五小时'
                },
                {
                    value: '16',
                    label: '十六小时'
                },
                {
                    value: '17',
                    label: '十七小时'
                },
                {
                    value: '18',
                    label: '十八小时'
                },
                {
                    value: '19',
                    label: '十九小时'
                },
                {
                    value: '20',
                    label: '二十小时'
                },
                {
                    value: '21',
                    label: '二十一小时'
                },
                {
                    value: '22',
                    label: '二十二小时'
                },
                {
                    value: '23',
                    label: '二十三小时'
                },
                {
                    value: '24',
                    label: '二十四小时'
                },
            ],
        }
    },
    components: {
        plateInput
    },
    computed: {
		...mapGetters(['userPhone', ])
	},
    created() {
        console.log(this.$route.query,'this.$route.query');
        if (this.$route.query.parkinglotId) {
            this.parkinglotId = this.$route.query.parkinglotId;
        }
        if (this.$route.query.couponTaskId) {
            this.couponTaskId = this.$route.query.couponTaskId;
        }
        if (this.$route.query.couponType) {
            this.couponType = this.$route.query.couponType;
        }
       
       
    },
    methods: {
        getPrecomputationMoney(){
            let params={
                couponTaskId:this.couponTaskId,
                recId:this.recId,
                parkinglotId:this.parkinglotId,
                businessphone:this.userPhone,
                hoursNum:this.checkedCouponId,
                money:this.unpaidMoney
            }
            getPrecomputation(params).then(res=>{
                console.log(res,'与抵扣金额');
              
              
            })
        },
        getPlateNumber(data) {
            console.log('传值', data);
            this.$set(this.plateForm, 'platenumber', data);
        },

        checkParkHour() {
            if (this.plateForm.platenumber && this.plateForm.platenumber.length >= 7) {
                getRecordByPlateNo({ plateno: this.plateForm.platenumber, parkinglotId: this.parkinglotId }).then(res => {
                    console.log(res, '停车时长');
                    if (res.code === 200) {
                        this. recId = res.data.id
                        // this.unpaidMoney =  res.data.unpaidMoney
                        
                        // this.$weui.alert("该车停车时长: " + res.data.parkHours);
                       
                            if (res.data.status=="1") {
                                this.$weui.alert('该车已提前支付过')
                            }else{
                                if (res.data.couponid) {
                                    this.$weui.alert('该车用过优惠券，无法代付')
                                }else{
                                    this.$router.push({name:'PaymentAmount',query:{plateno:res.data.plateno,parkHours:res.data.parkHours,inTime:res.data.inTime,updateTime:res.data.updateTime, recId:this.recId,unpaidMoney:res.data.unpaidMoney,couponTaskId:this.couponTaskId,parkinglotId:this.parkinglotId,couponType:this.couponType}});
                                }
                              
                            }
                           
                        
                       
                        
                    }
                });
            } else {
                this.$weui.alert('车牌号长度有误！')
            }
        },
        chooseRationType() {
            this.$weui.picker(this.checkedCouponOptions, {
                onChange: result => {
                    this.checkedCoupon = result[0].label;
                    this.checkedCouponId = result[0].value;
                    // this.getPrecomputationMoney()

                },
                onConfirm: result => {
                    this.checkedCoupon = result[0].label;
                    this.checkedCouponId = result[0].value;
                    this.getPrecomputationMoney()
                },
                // onClose: () => {
                //     this.userChooseCoupon()
                // },
                title: '可选优惠券'
            });
        },
        toPay() {
            let payForm = {
             
                totalAmount: parseFloat(this.amountReceived).toFixed(2),
                goodsType: 7,
                parkinglotId: this.parkinglotId,
                payType: 13,
                recId:this. recId,
                hoursNum:  this.checkedCouponId,
                couponTaskId:this.couponTaskId,
                openId: localStorage.getItem('userOpenId')
            };
            if ( this.couponType==10&&!this. recId) {
                this.$weui.alert("代付必须查询停车时长");
            }else{
                pay(payForm).then(res => {
                if (res.code == 200) {
                    this.$pay(res)
                }
            })
            }
           
        },
    }
}
</script>

<style scoped></style>
